import { datadogLogs, StatusType } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

// Verbose diagnostic logs (logger.debug) are dropped client-side unless debug is
// explicitly enabled on the device: localStorage.setItem('silbo-log-level', 'debug') + reload.
const getLogLevel = (): StatusType =>
  localStorage.getItem('silbo-log-level') === 'debug' ? StatusType.debug : StatusType.info;

const {
  VITE_HTTP_PROXY,
  VITE_DATADOG_APPLICATION_ID,
  VITE_APPLICATION_ENV,
  VITE_APP_VERSION,
  VITE_DATADOG_CLIENT_TOKEN,
} = import.meta.env;
export const datadogInit = (apiUrl: string) => {
  const environment = VITE_APPLICATION_ENV;
  if (['prod', 'preprod', 'playground', 'staging'].includes(environment) || environment.includes('debug-pwa-service-worker')) {
    const proxy = VITE_HTTP_PROXY ? `${VITE_HTTP_PROXY}/datadog` : undefined;

    datadogLogs.init({
      version: VITE_APP_VERSION,
      clientToken: VITE_DATADOG_CLIENT_TOKEN || '',
      site: 'datadoghq.eu',
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      trackSessionAcrossSubdomains: true,
      service: 'mobile',
      proxy,
    });
    datadogLogs.logger.setLevel(getLogLevel());

    datadogRum.init({
      applicationId: VITE_DATADOG_APPLICATION_ID || '',
      clientToken: VITE_DATADOG_CLIENT_TOKEN || '',
      site: 'datadoghq.eu',
      env: environment,
      service: 'mobile',
      version: VITE_APP_VERSION,
      sessionSampleRate: 100,
      trackSessionAcrossSubdomains: true,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      allowedTracingUrls: [apiUrl],
      proxy,
    });
  }
};
